webpackJsonp([213720915766396],{

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/turf-fertilization.a613630e.jpg";

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(311);
	
	var _turfFertilization = __webpack_require__(482);
	
	var _turfFertilization2 = _interopRequireDefault(_turfFertilization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsPage = function ProjectsPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Projects | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _turfFertilization2.default, alt: 'Turf maintenance project' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Projects'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'See some of the projects we\'re proud of.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'projWrap' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'projIntro' },
	        'Recent Projects'
	      ),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'project' },
	        ' '
	      ),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement('div', { className: 'project' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'projectEnd' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'See our ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.facebook.com/icesnowlandscape/' },
	            'facebook'
	          ),
	          ' for more great examples.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us to learn about our capabilities.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	}; // this is a landing for the multiple other services
	exports.default = ProjectsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-83fff2b2c5ab497a1595.js